import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import DropFile from "@/components/base/DropFile.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileUploader',
  props: {
    accept: null,
    multiple: { type: Boolean }
  },
  emits: ["fileChanged"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'fileChanged', file: File | undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  accept: string;
  multiple: boolean;
}



const selectedFile = ref<File | undefined>();



const changeHandler = (inputFiles: File[]) => {
  if (!inputFiles || !inputFiles.length) {
    selectedFile.value = undefined;
    emit("fileChanged", undefined);
    return;
  }
  // eslint-disable-next-line prefer-destructuring
  selectedFile.value = inputFiles[0];
  emit("fileChanged", selectedFile.value);
};

return { __sfc: true,props, selectedFile, emit, changeHandler, DropFile }
}

})